import type { JSONContent } from '@tiptap/core';

export type MapType = 'us' | 'canada' | 'emea' | 'apac' | 'latam';

export interface MapRegion {
  id: string;
  mapVersionId: string;
  regionKey: string;
  name: string;
  description: JSONContent;
  createdAt: string;
  updatedAt: string;
}

export interface MapVersion {
  id: string;
  mapType: MapType;
  title: string;
  description: string;
  interactionMessage: string;
  regions: MapRegion[];
  createdAt: string;
  updatedAt: string;
}

export const MAP_TYPE_LABELS: Record<MapType, string> = {
  us: 'United States',
  canada: 'Canada',
  emea: 'EMEA',
  apac: 'APAC',
  latam: 'LATAM',
};

export const MAP_TYPES: readonly MapType[] = ['us', 'canada', 'emea', 'apac', 'latam'] as const;

export const MAP_TYPE_DEFAULT_DESCRIPTIONS: Record<MapType, string> = {
  us: 'Select your state or territory from the map or the menu below.',
  canada: 'Select your province or territory from the map or the menu below.',
  emea: 'Select your country from the map or the menu below.',
  apac: 'Select your country from the map or the menu below.',
  latam: 'Select your country from the map or the menu below.',
};
